/* unplugin-vue-components disabled */import { render } from "./MainHead.vue?vue&type=template&id=ea474624&scoped=true"
import script from "./MainHead.vue?vue&type=script&lang=js"
export * from "./MainHead.vue?vue&type=script&lang=js"

import "./MainHead.vue?vue&type=style&index=0&id=ea474624&scoped=true&lang=css"

import exportComponent from "D:\\PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea474624"]])

export default __exports__